import {makeStyles} from '@material-ui/styles';

const style = makeStyles(() => ({
    formControl: {
        width: '100%',
        leftMargin: '60px',
    },
    inputWrapper: {
        border: '0 !important',
        background: 'rgba(83, 37, 47, 0.05)',
        borderRadius: 4,
        '& .MuiInput-root': {
            '&:hover:not(.Mui-disabled)': {
                '&:before': {
                    border: 0,
                }
            },
            '&:before': {
                border: 0,
            },
            '&:after': {
                border: 0,
            }
        },
        '& label': {
            color: '#53252f',

            '&.Mui-disabled': {
                color: '#aaa',
            },
            '&.Mui-focused': {
                color: '#999',
            }
        },
        '& input': {
            fontSize: '16px',
            color: 'black',
            fontWeight:'normal',
            minHeight: 50,
            lineHeight: '50px',
            padding: 10,
            '&::-webkit-input-placeholder': { 
                color: '53252f',
            },            
            '&:-ms-input-placeholder' :{ 
                color: '53252f',
            },            
            '&::placeholder': {
                color: '53252f',
            },
            '&:-webkit-autofill': {
                boxShadow: '0 0 0 30px inset #eee',
                color: '#53252f',
            },
            '&.Mui-disabled': {
                color: '#53252f',
                textFillColor: '#eee',
            }
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0',
        },
    },
}));

export default style;